import { Warning } from "@mui/icons-material";
import { Alert, List, ListItem, ListItemIcon, ListItemText, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import { GqlJob } from "~/__generated__";

type Props = {
    job: GqlJob;
};

export default function UserImportFeedback({ job }: Props) {
    const { t } = useTranslation("user");
    const output = job.output as
        | {
              total?: number;
              users?: number;
              fieldworkers?: number;
              errors?: {
                  row: object;
                  error: string;
              }[];
              errorMessage?: string;
          }
        | undefined;

    if (!output) return undefined;

    return (
        <Stack>
            <Typography variant="caption">
                {t("userImportFeedback.imported", {
                    success: output.users ?? 0,
                    total: output.total ?? 0,
                })}
            </Typography>

            <Typography variant="caption">
                {t("userImportFeedback.newFieldworkers", {
                    newFieldworkers: output.fieldworkers ?? 0,
                })}
            </Typography>

            {(output.total ?? 0) - (output.users ?? 0) > 0 && (
                <Typography variant="h6" color="error">
                    {t("userImportFeedback.couldNotImport", {
                        usersNotImported: (output.total ?? 0) - (output.users ?? 0),
                    })}
                </Typography>
            )}

            <List>
                {output.errors?.map(error => (
                    <ListItem>
                        <ListItemIcon>
                            <Warning />
                        </ListItemIcon>

                        <ListItemText>
                            <Typography variant="body2">{error.error}</Typography>
                            <br />
                        </ListItemText>
                    </ListItem>
                ))}
            </List>

            {output.errorMessage && (
                <Alert severity="error">
                    <Typography variant="body2" color="error">
                        {output.errorMessage}
                    </Typography>
                </Alert>
            )}
        </Stack>
    );
}
